import { Drawer, Descriptions, Divider, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

function ViewPlantType({ open, onClose, plantType }) {
  if (!plantType) {
    return null;
  }

  const renderValue = value => {
    return value !== null && value !== undefined && value !== '' ? value : 'N/A';
  };

  return (
    <Drawer
      title="Plant Type Details"
      width={700}
      onClose={onClose}
      open={open}
      footer={null}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Code">
          {renderValue(plantType.code)}
        </Descriptions.Item>
        <Descriptions.Item label="Name">
          {renderValue(plantType.name)}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag
            color={plantType.status === 'Active' ? 'green' : 'red'}
            icon={
              plantType.status === 'Active' ? (
                <CheckCircleOutlined />
              ) : (
                <CloseCircleOutlined />
              )
            }
          >
            {plantType.status === 'Active' ? 'Active' : 'Inactive'}
          </Tag>
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Audit Information</Divider>

      <Descriptions column={1} bordered>
        <Descriptions.Item label="Created At">
          {plantType.created_at
            ? dayjs(plantType.created_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Created By">
          {plantType.created_by_info && typeof plantType.created_by_info === 'object'
            ? `${plantType.created_by_info.first_name || ''} ${
                plantType.created_by_info.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {plantType.updated_at
            ? dayjs(plantType.updated_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated By">
          {plantType.updated_by_info && typeof plantType.updated_by_info === 'object'
            ? `${plantType.updated_by_info.first_name || ''} ${
                plantType.updated_by_info.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}

export default ViewPlantType;
